import { ERROR_PATH } from '../routeNames';
import getErrorRedirect from './getErrorRedirect';
import { useNavigateWithHistory } from '../useNavigateWithHistory';
import { useErrorContext } from '../../error/ErrorBoundaryContext';

export const useErrorRedirects = () => {
  const { errorToHandle } = useErrorContext();
  const navigate = useNavigateWithHistory();
  const errorRedirect = errorToHandle ? getErrorRedirect(errorToHandle) : null;

  if (errorRedirect) {
    const { pathname, state } = errorRedirect;

    if (!pathname || location.pathname === `/${ERROR_PATH}`) return;

    navigate(pathname, {
      state,
      replace: true,
    });
  }
};
